import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate } from "@angular/router";
import { OidcClientService } from "@upmc-healthplan-npm/oidc-client";
import { CookieStorage } from "../shared/services/cookie-storage/cookie-storage.service";

@Injectable({
  providedIn: 'root'
})
export class LoginRedirectGuard implements CanActivate {
  constructor(private auth: OidcClientService, private cookies: CookieStorage) { }

  canActivate({queryParams}: ActivatedRouteSnapshot) {
    this.cookies.setItem("intended-route", queryParams.route);
    if(queryParams.client_id) {
      this.auth.setClientId(queryParams.client_id);
      sessionStorage.setItem("client_id", queryParams.client_id);
    }
    if(queryParams.authority) {
      this.auth.setAuthority(queryParams.authority);
      sessionStorage.setItem("authority", queryParams.authority);
    }
    this.auth.signIn();
    return false;
  }
}